<template>
  <div
    class="h-full p-10px absolute text-white z-99 w-468px rounded-2px right-35px"
    :style="{
      height: location.height,
      top: location.top,
      right: location.float === 'right' ? '25px' : '',
      left: location.float === 'left' ? '25px' : '',
    }"
    id="AddDeviceModel"
  >
    <div>
      <div>
        <el-row class="mb-10px">
          <el-col :span="21">
            <span class="text-14px">新增动效</span>
          </el-col>
          <el-col :span="3" class="text-right">
            <span
              class="iconfont float-right cursor-pointer icon-line-close text-12px"
              @click="closeComponent"
            ></span>
          </el-col>
        </el-row>
      </div>
      <div class="w-full">
        <el-select
          ref="classfiySelectTree"
          popper-class="document_select-popper select-tree"
          value-key=""
          clearable
          filterable
          class="w-full"
          size="small"
          @clear="resetDeviesInfo"
          v-model="kineticEffectInfo.folderId"
          placeholder="分类"
        >
          <el-option :label="kineticEffectInfo.pathName" :value="kineticEffectInfo.folderId">
            <el-tree
              :props="{
                label: 'name',
                children: 'children',
              }"
              class="text-white"
              node-key="id"
              highlight-current
              :data="folderTreeData"
              @node-click="classfiyNodeClick"
              :expand-on-click-node="false"
            ></el-tree>
          </el-option>
        </el-select>
      </div>
      <el-row type="flex" align="middle" class="mt-5px">
        <el-col :span="21"
          ><el-input placeholder="名称搜索" v-model="keyWords" clearable size="small"></el-input
        ></el-col>
        <el-col :span="3" class="text-right">
          <el-tooltip effect="dark" content="搜索" placement="top">
            <el-button
              type="primary"
              size="small"
              class="iconfont icon-line-search"
              @click="getComponentList"
            ></el-button>
          </el-tooltip>
        </el-col>
      </el-row>
    </div>
    <div
      class="form_body mt-10px text-white w-full h-[calc(100%-170px)] overflow-y-auto pt-10px pr-5px pb-10px pl-5px"
      v-loading="listLoading"
    >
      <div class="card_list" v-if="listData.length">
        <div
          class="card w-94px h-150px mt-10px mb-10px mr-7px ml-7px"
          v-for="(item, index) in listData"
          :key="index"
        >
          <div class="card_img w-94px h-120px">
            <el-image class="w-full h-full" :src="item.imageUrl">
              <div slot="error" class="text-center leading-132px">
                <i class="el-icon-picture-outline text-24px"></i></div
            ></el-image>
          </div>
          <div
            class="card_text flex w-full h-30px"
            @click="
              (e) => {
                e.stopPropagation()
              }
            "
          >
            <el-tooltip effect="dark" :content="item.name" placement="top" :open-delay="1000">
              <el-checkbox v-model="item.select" class="flex items-center">{{
                item.name
              }}</el-checkbox>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="w-full h-full flex items-center justify-center" v-else>
        <span class="text-14px">暂无数据</span>
      </div>
    </div>
    <div
      class="mt-10px w-full flex items-center justify-between"
      @click="
        (e) => {
          e.stopPropagation()
        }
      "
    >
      <el-radio-group v-model="loadPositionType" class="flex items-center">
        <el-radio size="small" :label="1">锚点位置</el-radio>
        <el-radio size="small" :label="3">按模型</el-radio>
        <el-radio size="small" :label="2">按节点</el-radio>
      </el-radio-group>
      <el-select
        v-model="aabbFaceCenter"
        placeholder="中心"
        size="mini"
        popper-class="document_select-popper"
      >
        <el-option
          v-for="item in loadLocation"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button type="primary" class="ml-10px" size="mini" @click="createdNewModel"
        >新增</el-button
      >
    </div>
    <!-- 动效进度条 -->
    <player-progress
      :loadType="loadType"
      :percentage="loadPercentage"
      v-if="showLoadProgress"
    ></player-progress>
  </div>
</template>
<script>
import { find, last, filter, forEach, map } from 'lodash'
import { AnimationDirectoryApi, AnimationApi } from '@wiz-api/material-management'
import { FileApi } from '@wiz-api/file-management'
import { loadParticle, isJSONObj, generateGUID, EnumObjectTypes } from '../../assets/js/scene/scene'
import downloadFile from '../../assets/js/model/modelDownload'
import cloudRender from '../../assets/js/model/index'

const fileApi = new FileApi()
const animationDirectoryApi = new AnimationDirectoryApi()
const animationApi = new AnimationApi()
const PlayerProgress = () => {
  return import('../model/PlayerProgress')
}
export default {
  components: {
    PlayerProgress,
  },
  name: 'kineticEffect',
  props: ['location', 'player', 'loadModelStatus', 'customProps'],
  data() {
    return {
      currentMaterialFile: {}, // 动效贴图文件信息
      loadPosition: [],
      showLoadProgress: false,
      loadPercentage: 0,
      loadType: '',
      fileId: [],
      currentModelParams: {},
      modelParams: '', // 动效信息
      // 元件基本信息
      kineticEffectInfo: {
        seqNo: '',
        type: '',
        name: '',
        pathName: '',
        modelFileList: [],
        textureFileList: [],
        thumbnailFileList: [],
        fileName: '',
        thumbnails: '',
        templateAttrSetList: [
          {
            attrValueList: [],
            attributeTemplate: {},
            tableName: '',
            templateId: '',
          },
        ],
      },
      folderTreeData: [],
      dialogInfo: {},
      keyWords: '',
      loadPositionType: 1,
      checkList: [],
      listData: [],
      currentFolderId: '',
      typeList: [],
      // 方位
      loadLocation: [
        {
          value: 'Z',
          label: '上方',
        },
        {
          value: 'ZN',
          label: '下方',
        },
        {
          value: 'YN',
          label: '前方',
        },
        {
          value: 'Y',
          label: '后方',
        },
        {
          value: 'XN',
          label: '左方',
        },
        {
          value: 'X',
          label: '右方',
        },
      ],
      aabbFaceCenter: 'YN',
      currentSelectData: {},
      listLoading: false,
    }
  },
  computed: {
    // 动效相关设置
    modelSetting() {
      return Wiz.globalSettings.globalConfig?.modelSetting || {}
    },
  },
  async created() {
    this.getComponentList()
    this.getFolderTreeData()
    this.player.Native.ModelTree.EventSelectItemChanged.connect(this.watchPickupMsg)
  },
  beforeDestroy() {
    this.player.Native.ModelTree.EventSelectItemChanged.disconnect(this.watchPickupMsg)
  },
  methods: {
    /* 加载动效相关start */
    // 监听点选事件
    watchPickupMsg(data) {
      this.currentSelectData = data && data.item ? data : {}
    },
    /**
     * @description: 检查是否动效是否存在 不存在则下载
     * @param {*}
     * @return {*}
     */
    async checkModel(modelParams) {
      const currentModelFile = find(modelParams.medias, ['mediaType', 1])
      if (!currentModelFile) {
        this.$message.error('没有找到动效文件')
        return
      }
      this.$set(currentModelFile, 'name', modelParams.name)
      this.$set(currentModelFile, 'modelId', modelParams.id)
      const currentZip = find(modelParams.medias, ['mediaType', 2])
      if (currentZip) {
        this.checkModelMaterial(currentZip, currentModelFile)
      } else {
        this.getCurrentModelFile(currentModelFile, {})
      }
    },
    // 检查动效材质文件
    async checkModelMaterial(material, model) {
      const url = `data://../apps/${this.modelSetting.folderName}/particle/${model.fileInfoId}/${model.fileInfoId}.zip`
      const fileInfo = {
        id: material.fileInfoId,
        url,
        fileType: 'zip',
      }
      const apiConfig = {
        path: `${Wiz.GetApiClientInstance()?.basePath}/api/file-management/files/${
          material.fileInfoId
        }/download`,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${Wiz.AuthHooks.GetToken()}`,
        },
      }
      const res = await downloadFile(
        this.player,
        fileInfo,
        apiConfig,
        this.progressMsg,
        this.downloadMaterialMsg(material, model)
      )
      if (res.type === 0 && res.success) {
        this.getCurrentModelFile(model, material, res.tempsUrl)
      } else {
        this.showLoadProgress = true
        this.loadType = '下载中...'
      }
    },
    // 检查动效是否存在
    async getCurrentModelFile(model, material, tempsUrl) {
      let fileType = 'efk'
      const [error, result] = await fileApi.get(model.fileInfoId)
      if (!error) {
        fileType = last(result.name.split('.'))
      }
      const url = `data://../apps/${this.modelSetting.folderName}/particle/${model.fileInfoId}/${model.fileInfoId}.${fileType}`
      const fileInfo = {
        id: model.fileInfoId,
        url,
        fileType,
      }
      const apiConfig = {
        path: `${Wiz.GetApiClientInstance()?.basePath}/api/file-management/files/${
          model.fileInfoId
        }/download`,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${Wiz.AuthHooks.GetToken()}`,
        },
      }
      const res = await downloadFile(
        this.player,
        fileInfo,
        apiConfig,
        this.progressMsg,
        this.downloadMsg(url, model, material)
      )
      if (res.type === 0 && res.success) {
        // 有动效就加载动效
        this.addKineticEffect(url, model, material, tempsUrl)
      } else {
        this.showLoadProgress = true
        this.loadType = '下载中...'
      }
    },
    // 监听下载动效是否成功
    downloadMsg(url, model, material) {
      const that = this
      const fun = async (file, err) => {
        that.loadPercentage = 0
        that.showLoadProgress = false
        if (err) {
          that.$message.warning(`下载文件失败，${file}, ${err}`)
          return
        }
        that.addKineticEffect(url, model, material) // 动效下载成功就加载动效
      }
      return fun
    },
    // 监听下载动效是否成功
    downloadMaterialMsg(material, model) {
      const that = this
      const fun = async (file, err) => {
        that.showLoadProgress = false
        that.loadPercentage = 0
        if (err) {
          that.$message.warning(`下载贴图文件失败，${file}, ${err}`)
          return
        }
        setTimeout(() => {
          that.getCurrentModelFile(model, material)
        }, 1500)
      }
      return fun
    },
    // 监听下载进度
    progressMsg(file, bytesReceived, bytesTotal) {
      if (bytesTotal) {
        this.loadPercentage = (bytesReceived / bytesTotal) * 100
      }
    },
    checkModelLoad(data) {
      this.loadType = '加载中...'
      this.showLoadProgress = true
      this.loadPercentage = data * 100
    },
    /**
     * @description: 监听动效加载完成
     * @param {*} data
     * @return {*}
     */
    checkModelLoadEnd() {
      this.showLoadProgress = false
      this.player.Native.Model.EventProgress.disconnect(this.checkModelLoad)
      this.player.Native.Model.EventProgressEnd.disconnect(this.checkModelLoadEnd)
    },
    // 加载动效
    async addKineticEffect(targetUrl, model, material) {
      this.player.Native.Model.EventProgress.connect(this.checkModelLoad)
      this.player.Native.Model.EventProgressEnd.connect(this.checkModelLoadEnd)
      const rootItems = await this.player.Native.ModelTree.getRootItems()
      const currentRoot = _.find(rootItems, (val) => {
        return val.code && JSON.parse(val.code) && JSON.parse(val.code).type === 'Root'
      })
      const rootNode =
        !_.isNil(currentRoot) && currentRoot.nodePtr
          ? currentRoot.nodePtr
          : await this.player.Native.NodeProxy.rootNode()
      let parentNode = null
      if (
        !this.customProps.currentNodeData?.code ||
        !isJSONObj(this.customProps.currentNodeData?.code) ||
        (isJSONObj(this.customProps.currentNodeData?.code) &&
          EnumObjectTypes.includes(JSON.parse(this.customProps.currentNodeData?.code).type))
      ) {
        parentNode = rootNode
      } else {
        parentNode = this.customProps.currentNodeData?.nodePtr
      }
      const currentNode = await loadParticle(
        targetUrl,
        model.name,
        parentNode || rootNode,
        this.player
      ) // 加载模型
      if (!_.isEmpty(this.loadPosition)) {
        await this.player.Native.NodeProxy.setGlobalTranslation(currentNode, this.loadPosition)
      }
      const uuid = generateGUID()
      await this.player.Native.NodeProxy.setNodeInfo(currentNode, {
        code: JSON.stringify({
          id: uuid,
          modelId: model.modelId,
          type: 'dynamicEffects',
          filePath: targetUrl,
          modelFileId: model.fileInfoId,
          materialFileId: material.fileInfoId || '',
        }),
      })
      this.checkList = []
      this.fileId = []
      this.$emit('componentEmit', 'addModel', currentNode)
      this.$message.success('添加成功')
    },

    /* 加载动效相关end */
    /* ---------- 类别路径选择相关 start---------- */
    classfiyNodeClick(node) {
      this.kineticEffectInfo.folderId = node.id
      this.kineticEffectInfo.pathName = node.pathName ? node.pathName : node.name
      this.$refs.classfiySelectTree.blur()
      this.getComponentList()
    },
    // 清空筛选
    resetDeviesInfo() {
      this.kineticEffectInfo.folderId = ''
      this.kineticEffectInfo.pathName = ''
    },
    // 获取目录树
    async getFolderTreeData() {
      const [err, res] = await animationDirectoryApi.getTree()
      if (!err) {
        this.folderTreeData = [{ name: '根目录', id: '', children: res }]
      }
    },
    // 动效点击事件
    async createdNewModel() {
      if (this.loadPositionType === 1) {
        const anchorPos = await this.player.Native.Camera.getAnchorPos()
        this.loadPosition = anchorPos
      } else if (this.loadPositionType === 2) {
        if (this.currentSelectData?.item || this.customProps.currentNodeData?.item) {
          const calcData = await this.player.Native.ModelTree.calcItemAabbData(
            this.currentSelectData?.item || this.customProps.currentNodeData?.item
          )
          if (calcData && calcData.aabb) {
            this.loadPosition = Aabb.faceCenter(calcData.aabb, this.aabbFaceCenter)
          } else {
            this.$message.warning('请重新选择节点')
          }
        } else {
          this.$message.warning('请选择节点')
          return
        }
      } else {
        this.loadPosition = []
      }
      const checkList = filter(this.listData, ['select', true])
      for (let i = 0; i < checkList.length; i += 1) {
        this.checkModel(checkList[i])
      }
      forEach(this.listData, (item) => {
        item.select = false
      })
    },
    async getImageContent(id) {
      // 获取图片内容
      const [error, result] = await fileApi.getImageBaseString(id)
      if (!error) {
        return `data:image/png;base64,${result.base64}`
      }
      return ''
    },
    // 加载元件列表
    async getComponentList() {
      this.listData = []
      this.listLoading = true
      const [err, res] = await animationApi.getList({
        name: this.keyWords,
        directoryId: this.kineticEffectInfo.folderId,
        skipCount: 0,
        maxResultCount: 1000,
      })
      this.listLoading = false
      if (!err) {
        this.listData = map(res.items, (item) => {
          return {
            ...item,
            select: false,
            imageUrl: '',
          }
        })
        forEach(this.listData, async (item) => {
          const thumbnailId = find(item.medias, ['mediaType', 3])
          if (thumbnailId) {
            const imgRes = await this.getImageContent(thumbnailId.fileInfoId)
            this.$set(item, 'imageUrl', imgRes)
          }
        })
      }
    },
    // 关闭弹窗
    closeComponent() {
      if (this.tableLoading) {
        return
      }
      this.$emit('closeComponent', 'KineticEffect')
    },
  },
}
</script>
<style lang="scss">
@import '../../assets/style/select';

.select-tree .el-select-dropdown__item {
  height: unset !important;
  line-height: unset !important;
}

.select-tree .el-tree-node__label {
  color: #fff !important;
}
</style>
<style lang="scss" scoped>
@import '../../assets/style/index';

::v-deep .player_progress {
  position: fixed !important;
}

::v-deep .el-checkbox__label {
  font-size: 12px !important;
}

#AddDeviceModel {
  background-color: rgba(0, 18, 55, 0.3) !important;
  transition: left 0.3s;
}

::v-deep .el-radio {
  margin-right: 10px !important;
}

.form_body {
  background: rgba(24, 41, 72, 0.5);

  ::v-deep .el-loading-mask {
    background: rgba(24, 41, 72, 0.8) !important;
  }

  .card {
    background: none;
    border: none;

    ::v-deep .el-card__body {
      padding: 0 !important;
      background: none;
    }

    ::v-deep .el-checkbox__label {
      overflow: hidden;
      width: 60px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .card_img {
    img {
      width: 100%;
      height: 100%;
    }

    background-color: #383b3b !important;
  }

  .card_list {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
  }

  .card_text {
    background: none;

    p {
      height: 30px;
      font-size: 12px;
      text-align: center;
      color: #fff;
      line-height: 30px;
    }

    .el-checkbox {
      margin: 5px 12px 0 8px;
      color: #fff;
    }
  }
}
</style>
